//
//
//
//
//
//
//
//
//

import utils from '@/utils/utils';

export default {
  name: 'remaining-time',
  props: {
    remainingSeconds: {
      type: Number | String,
      default: 0,
    },
  },
  data(){
    return {
      minute: 0,
      second: 0,
    };
  },
  watch: {
    remainingSeconds(cur){
      this.remainingTime(Number(cur));
    },
  },
  mounted(){
    this.remainingTime(Number(this.remainingSeconds));
  },
  methods: {
    remainingTime(source){
      let timer = null;

      this.transformSecondToMinutes(source);
      if(source > 0){
        clearInterval(timer);
        timer = setInterval(() => {
          --source;
          if(source >= 0){
            this.transformSecondToMinutes(source);
          }else{
            clearInterval(timer);
            this.$emit('on-end');
          }
        }, 1000);
      }
    },

    transformSecondToMinutes(seconds){
      this.minute = utils.zeroPad(parseInt(seconds / 60));
      this.second = utils.zeroPad(seconds % 60);
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/RemainingTime/RemainingTime.vue